import React, { Component } from 'react'
import { NotificationManager } from 'react-notifications'
import axios from 'axios'
import qs from 'querystring'
import './styles.css'

import imgLogo from '../../assets/images/logo.svg'
import imgPlay from '../../assets/images/play.svg'

class ResetPassword extends Component {

  constructor (props) {
    super(props)

    this.state = {
      password: '',
      confirmPassword: '',
    }
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  resetPassword = () => {
    let { password, confirmPassword } = this.state

    if (!password) {
      NotificationManager.error('Please input new password', 'Error')
      return
    }

    if (!confirmPassword) {
      NotificationManager.error('Please input confirmation password', 'Error')
      return
    }

    if (password !== confirmPassword) {
      NotificationManager.error('Confirmation password is wrong', 'Error')
      return
    }

    if (password.length < 6) {
      NotificationManager.error('Password needs to be at least 6 characters', 'Error')
      return
    }

    let token = qs.parse(this.props.location.search.replace('?', ''), { ignoreQueryPrefix: true }).token

    axios.post('https://us-central1-lucky-miner.cloudfunctions.net/resetPassword', qs.stringify({
      password: password,
      token: token,
    })).then(res => {
      NotificationManager.success('Password has been reset', 'Success')
      this.props.history.push('/home')
    })
    .catch(err => {
      console.log(err)
      NotificationManager.error('Failed to reset password', 'Error')
    })
  }

  render () {
    return (
      <div className='div-reset-password-container'>
        {/* <div className='div-buttons'>
          <span className='clickable' onClick={ this.onWeeklyDrawing }>This week's drawing</span>
          <span className='clickable' onClick={ this.onWinners }>WINNERS</span>
          <span className='clickable' onClick={ this.onFAQ }>FAQ</span>
        </div> */}

        <div className='div-center'>
          <img className='img-logo' src={imgLogo} alt='logo'/>
          <div className='div-description'>
            New Password
          </div>
          <div className='div-input-wrapper'>
            <input type='password' autoFocus onChange={this.onChange} name='password' value={this.state.password} placeholder='New Password'/>
          </div>
          <div className='div-input-wrapper'>
            <input type='password' onChange={this.onChange} name='confirmPassword' value={this.state.confirmPassword} placeholder='Confirm New Password'/>
          </div>
          <img className='img-play clickable' src={imgPlay} alt='reset' onClick={ this.resetPassword }/>
        </div>
      </div>
    )
  }
}

export default ResetPassword



// WEBPACK FOOTER //
// ./src/containers/ResetPassword/index.js